/** @graphql cc **/

import gql from 'graphql-tag';

export const AppNavigationUnifiedQuery = gql`
	query AppNavigationUnifiedQuery {
		lookAndFeel {
			custom {
				horizontalHeader {
					backgroundColor
					primaryNavigation {
						highlightColor
					}
				}
			}
		}
		siteConfiguration {
			customSiteLogo
		}
		siteSettings {
			siteTitle
			showApplicationTitle
		}
		siteDescription {
			logoUrl
		}
		user: confluence_atlassianUser(current: true) {
			id
			displayName
			photos {
				value
				isPrimary
			}
		}
		# This data is a pre-requisite for rendering the People menu.
		# Including this fragment helps to ensure the People menu will be SSR'd properly.
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				permissionType
			}
		}
	}
`;
